var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"f-btn",style:({padding:_vm.icon==undefined|| _vm.icon==''?'5px 16px':'5px 8px'}),on:{"click":_vm.handleClick}},[(_vm.icon)?_c('svg-icon',{style:({fontSize:_vm.iconSize}),attrs:{"icon-class":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d7f6b082","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/FButton2/index.vue
// module id = null
// module chunks = 